
































import {Component, Emit, Prop, Vue} from 'vue-property-decorator';
import {PUCDataReq, PostUpsertContentsReq} from '@/model/dto/req/contents/post-upsert-contents-req';
import {PUADataReq, PostUpsertAboutReq} from '@/model/dto/req/about/post-upsert-about-req';
import {PUHDataReq, PostUpsertHeadlineReq} from '@/model/dto/req/headline/post-upsert-headline-req';
import {PUMDataReq, PostUpsertMenuReq} from '@/model/dto/req/menu/post-upsert-menu-req';
import {DialogBeforePostInterface} from '@/model/interfaces/content-interface';
import contentsModule from '@/model/store/modules/contents-module';

@Component
export default class PreviewDialog extends Vue {
  /** Data **/
  private display: boolean = false;

  /** Props **/
  @Prop({default: ''}) public title!: string;
  @Prop({default: ''}) public message!: string;
  @Prop({default: ''}) public data!: PUCDataReq;
  @Prop({default: ''}) public accountData!: PUADataReq | PUHDataReq | PUMDataReq;

  get contentsTitle() {
    if (this.data) {
      let title: string = this.data?.title ?? '';
      title = this.data.titleNew && this.data.titleNew !== null && this.data.titleNew !== '' ? this.data.titleNew : this.data.title;
      return title;
    } else if (this.accountData) {
      return this.accountData?.title ?? '';
    } else {
      return '';
    }
  }

  get contentsText() {
    if (this.data) {
      let text: string = this.data?.text ?? '';
      text = this.data.textNew && this.data.textNew !== null && this.data.textNew !== '' ? this.data.textNew : this.data.text;
      return text;
    } else if (this.accountData) {
      return this.accountData?.text ?? '';
    } else {
      return '';
    }
  }

  /** Methods **/
  public open(param?: any): void {
    this.display = true;
  }

  public close(): void {
    this.display = false;
  }

  private onPushCancelBtn(): void {
    this.close();
  }

  @Emit('onPushEnterBtn')
  private async onPushEnterBtn(): Promise<void> {
    this.close();
  }
}
